var map = {
	"./en-au": 64,
	"./en-au.js": 64,
	"./en-ca": 63,
	"./en-ca.js": 63,
	"./en-gb": 62,
	"./en-gb.js": 62,
	"./en-ie": 61,
	"./en-ie.js": 61,
	"./en-nz": 60,
	"./en-nz.js": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 137;